@if (initialized) {
    <div>
        <!-- View Mode Selector -->
        <div class="mb-3 flex justify-content-between align-items-center gap-3 mt-3 p-3 bg-white border-bottom-1 border-300">
            <div class="flex align-items-center gap-2">
                <h4 class="m-0 text-xl font-medium">{{dto?.name || 'Rolle'}}</h4>
                @if (selectedViewMode === 'node' && displayMode) {
                    <span class="display-mode-badge text-xs font-semibold px-2 py-1 border-round"
                          [ngClass]="getDisplayModeColorClass()">
                        <i [class.fa-light]="true" [class]="getDisplayModeIcon()"></i>
                        <span class="ml-1">{{ getDisplayModeLabel() }}</span>
                    </span>
                }
            </div>
            <p-selectButton
                [options]="viewModeOptions"
                [(ngModel)]="selectedViewMode"
                (onChange)="onViewModeChange($event)"
                optionLabel="label"
                optionValue="key">
                <ng-template let-item pTemplate="item">
                    <div class="flex align-items-center gap-2 px-3">
                        <i [class]="item.icon"></i>
                        <span>{{ item.label }}</span>
                    </div>
                </ng-template>
            </p-selectButton>
        </div>

        @if (selectedViewMode === 'node') {
            <!-- Node View - No sidebar navigation -->
            <mvs-config-node-view
                (onDisplayModeChange)="handleDisplayModeChange($event)"
                [config]="roleNodeViewConfig"
                [rootEntityId]="objectIdentifier.objectId"
                [rootEntityName]="dto?.name || 'Rolle'"
                [rootEntityIcon]="'fa-solid fa-user-shield'"
                (onNodeSelect)="handleNodeSelect($event)"
                (onAddChild)="handleAddChild($event)"
                (onNodeEdit)="handleNodeEdit($event)"
                (onBusyChange)="handleNodeBusyChange($event)">

                <!-- Template for Module nodes (um.RoleAuthModule) -->
                <ng-template mvs-config-node-template-directive
                             forEntityType="um.RoleAuthModule"
                             [forNodeType]="ConfigNodeTypeEnum.TERMINAL"
                             let-entity="entity">
                    <div class="flex align-items-center gap-2">
                        <i class="fa-solid fa-sitemap text-blue-500"></i>
                        <span>{{ entity?.module || 'Modul' }}</span>
                    </div>
                </ng-template>

                <!-- Template for Object Type nodes (um.RoleAuthObjectType) -->
                <ng-template mvs-config-node-template-directive
                             forEntityType="um.RoleAuthObjectType"
                             [forNodeType]="ConfigNodeTypeEnum.TERMINAL"
                             let-entity="entity">
                    <div class="flex align-items-center gap-2">
                        <i class="fa-solid fa-th-large text-purple-500"></i>
                        <span>{{ entity?.objectTypeDtoName || 'Objekttyp' }}</span>
                    </div>
                </ng-template>

                <!-- Template for Field Restriction nodes (um.RoleAuthFieldRestriction) -->
                <ng-template mvs-config-node-template-directive
                             forEntityType="um.RoleAuthFieldRestriction"
                             [forNodeType]="ConfigNodeTypeEnum.TERMINAL"
                             let-entity="entity">
                    <div class="flex align-items-center gap-2">
                        <i class="fa-solid fa-eye-slash text-yellow-500"></i>
                        <span>{{ entity?.fieldName || 'Feldeinschränkung' }}</span>
                    </div>
                </ng-template>

                <!-- Template for Direct Access nodes (um.RoleAuthDirectAccess) -->
                <ng-template mvs-config-node-template-directive
                             forEntityType="um.RoleAuthDirectAccess"
                             [forNodeType]="ConfigNodeTypeEnum.TERMINAL"
                             let-entity="entity">
                    <div class="flex align-items-center gap-2">
                        <i class="fa-solid fa-key text-indigo-500"></i>
                        <span>{{ entity?.objectTypeDtoName || 'Direktzugriff' }}</span>
                    </div>
                </ng-template>

                <!-- Template for Contract nodes (cm.RoleAuthContract) -->
                <ng-template mvs-config-node-template-directive
                             forEntityType="cm.RoleAuthContract"
                             [forNodeType]="ConfigNodeTypeEnum.TERMINAL"
                             let-entity="entity">
                    <div class="flex align-items-center gap-2">
                        <i class="fa-solid fa-file-contract text-orange-500"></i>
                        <span>Vertrag #{{ entity?.id || dto?.name || 'Vertrag' }}</span>
                    </div>
                </ng-template>

                <!-- Template for Customer nodes (cr.RoleAuthCustomer) -->
                <ng-template mvs-config-node-template-directive
                             forEntityType="cr.RoleAuthCustomer"
                             [forNodeType]="ConfigNodeTypeEnum.TERMINAL"
                             let-entity="entity">
                    <div class="flex align-items-center gap-2">
                        <i class="fa-solid fa-users text-green-500"></i>
                        <span>{{ entity?.roleDtoName || dto?.name || 'Kundenberechtigung' }}</span>
                    </div>
                </ng-template>

                <!-- Template for Customer Region nodes (cr.RoleAuthCustomerRegion) -->
                <ng-template mvs-config-node-template-directive
                             forEntityType="cr.RoleAuthCustomerRegion"
                             [forNodeType]="ConfigNodeTypeEnum.TERMINAL"
                             let-entity="entity">
                    <div class="flex align-items-center gap-2">
                        <i class="fa-solid fa-map-location-dot text-red-500"></i>
                        <span>{{ entity?.postalCode || 'Region' }}</span>
                    </div>
                </ng-template>

                <!-- Template for Customer Type nodes (cr.RoleAuthCustomerType) -->
                <ng-template mvs-config-node-template-directive
                             forEntityType="cr.RoleAuthCustomerType"
                             [forNodeType]="ConfigNodeTypeEnum.TERMINAL"
                             let-entity="entity">
                    <div class="flex align-items-center gap-2">
                        <i class="fa-solid fa-tags text-teal-500"></i>
                        <span>{{ entity?.customerTypeDtoName || 'Typ' }}</span>
                    </div>
                </ng-template>

            </mvs-config-node-view>
        } @else {
            <!-- Standard View - With sidebar navigation -->
            @if (uiMode == 'side') {
                <um-role-object-side
                    [objectIdentifier]="objectIdentifier"
                    [dto]="dto"
                    (onNavigationItems)="handleNavigationItems($event)">
                </um-role-object-side>
            } @else {
                <um-role-object-full
                    [objectIdentifier]="objectIdentifier"
                    [dto]="dto"
                    (onNavigationItems)="handleNavigationItems($event)">
                </um-role-object-full>
            }
        }
    </div>
}
